import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, apiErrorMessage } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useAuthGate } from "@/contexts/AuthGateContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const { runPending } = useAuthGate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const params = new URLSearchParams(location.search);
    const role = params.get("role") || "buscador";

    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id, role });
        setUser(data);
        toast.success(`¡Hola, ${data.name || data.email}!`);
        // clean hash from URL
        window.history.replaceState({}, "", "/");
        // If the user was gated into an action, run it now
        const handled = runPending();
        if (handled) return;
        navigate(data.role === "agente" ? "/dashboard" : "/", { replace: true });
      } catch (e) {
        toast.error(apiErrorMessage(e));
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, location.search, setUser, runPending]);

  return (
    <div className="p-24 text-center text-muted-foreground" data-testid="auth-callback">
      Autenticando con Google…
    </div>
  );
}
